import { Link } from 'react-router-dom';

export function Logo({ size = 32, word = true }: { size?: number; word?: boolean }) {
  const dark = document.documentElement.classList.contains('dark');
  return (
    <span className="inline-flex items-center gap-2.5">
      <img
        src={dark ? '/brand/orqforge-mark-white.svg' : '/brand/orqforge-mark.svg'}
        alt=""
        width={size}
        height={size}
        className="block shrink-0"
      />
      {word ? <span className="text-[1.05rem] font-medium leading-none">OrqForge</span> : null}
    </span>
  );
}
